<template>
	<div>
		
		<v-card>
			<v-card-title class="py-2 primary">
				<span class="tertiary--text">
					Coppie asse-regione - Accordo: {{ accordo.custom_id }} - Ragione Sociale Cliente: {{ accordo.cliente.ragione_sociale }}
				</span>
			</v-card-title>
			<v-card-text class="pt-6">
				<v-data-table
					:headers="headers"
					:items="coppieAsseRegione"
					:loading="isLoadingCoppieAsseRegione"
					:items-per-page="-1"
					height="calc(100vh - 350px)"
					fixed-header
					multi-sort
				>
				
				</v-data-table>
			</v-card-text>
			<v-card-actions>
				
				<v-spacer></v-spacer>
				<v-btn
					color="tertiary"
					@click="close()"
					class="black--text"
				>
					Chiudi
				</v-btn>
			</v-card-actions>
		</v-card>
	
	</div>
</template>

<script>
export default {
	props: {
		value: {
			default: null
		}
	},
	data() {
		return {
			headers: [
				{ text: 'Asse', value: 'asse' },
				{ text: 'Regione', value: 'regione' },
				{ text: 'Numero pratiche', value: 'numero_pratiche' }
			],
			isLoadingCoppieAsseRegione: false,
			coppieAsseRegione: []
		}
	},
	
	async created() {
		this.accordo = Object.assign({}, this.value);
		this.getCoppieAsseRegione();
	},
	
	methods: {
		close() {
			this.$emit('close');
		},
		getCoppieAsseRegione() {
			this.isLoadingCoppieAsseRegione = true;
			axios.get(`/api/accordi/${this.accordo.id}/coppie-asse-regione`)
				.then(response => {
					this.coppieAsseRegione = response.data;
				})
				.finally(() => {
					this.isLoadingCoppieAsseRegione = false;
				})
		}
	}
}
</script>

<style scoped>

</style>